// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AgentProfilePhoto = require("../../../v5/common/Agent/AgentProfilePhoto.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let NotificationTypeIcon = require("./NotificationTypeIcon.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationWidgetTexts = require("./NotificationWidgetTexts.bs.js");
let NotificationWidgetItem_notification_graphql = require("../../../__generated__/NotificationWidgetItem_notification_graphql.bs.js");
let NotificationWidgetItemSource_notification_graphql = require("../../../__generated__/NotificationWidgetItemSource_notification_graphql.bs.js");

let convertFragment = NotificationWidgetItem_notification_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetItem_notification_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetItem_notification_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationWidgetItem_notification_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetItem_notification_graphql.node, convertFragment, fRef);
}

let NotificationFragment_notificationStatus_decode = NotificationWidgetItem_notification_graphql.Utils.notificationStatus_decode;

let NotificationFragment_notificationStatus_fromString = NotificationWidgetItem_notification_graphql.Utils.notificationStatus_fromString;

let NotificationFragment = {
  notificationStatus_decode: NotificationFragment_notificationStatus_decode,
  notificationStatus_fromString: NotificationFragment_notificationStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = NotificationWidgetItemSource_notification_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetItemSource_notification_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetItemSource_notification_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationWidgetItemSource_notification_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetItemSource_notification_graphql.node, convertFragment$1, fRef);
}

let NotificationSourceFragment_draftOrigin_decode = NotificationWidgetItemSource_notification_graphql.Utils.draftOrigin_decode;

let NotificationSourceFragment_draftOrigin_fromString = NotificationWidgetItemSource_notification_graphql.Utils.draftOrigin_fromString;

let NotificationSourceFragment = {
  draftOrigin_decode: NotificationSourceFragment_draftOrigin_decode,
  draftOrigin_fromString: NotificationSourceFragment_draftOrigin_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let avatarStyle = "w-[50px] h-[50px]";

function NotificationWidgetItem(props) {
  let markAsRead = props.markAsRead;
  let notification = RescriptRelay_Fragment.useFragment(NotificationWidgetItem_notification_graphql.node, convertFragment, props.notification);
  let source = RescriptRelay_Fragment.useFragment(NotificationWidgetItemSource_notification_graphql.node, convertFragment$1, notification.fragmentRefs);
  let onClick = _e => {
    let match = notification.status;
    if (match === "UNREAD") {
      return markAsRead(notification.id);
    }
  };
  let match;
  switch (source.__typename) {
    case "AgentMatchLogNotification" :
      match = [
        "View match",
        "/match_log/" + source.agentMatchLog.databaseId
      ];
      break;
    case "UnfinishedDraftNotification" :
      let match$1 = source.draft;
      let match$2 = match$1.origin;
      if (match$2 !== undefined) {
        let exit = 0;
        if (match$2 === "BROADCAST_QUIET_SELLER" || match$2 === "REBROADCAST" || match$2 === "NEW") {
          switch (match$2) {
            case "NEW" :
              match = [
                "Resume draft",
                "/properties/new?draftId=" + match$1.databaseId
              ];
              break;
            case "BROADCAST_QUIET_SELLER" :
            case "REBROADCAST" :
              exit = 1;
              break;
          }
        } else {
          match = Stdlib.panic("Unexpected source.");
        }
        if (exit === 1) {
          let match$3 = match$1.publishedProperty;
          match = match$3 !== undefined ? [
              "Resume draft",
              `/properties/` + match$3.id + `/broadcast?resumingDraft=1`
            ] : Stdlib.panic("Unexpected source.");
        }
      } else {
        match = Stdlib.panic("Unexpected source.");
      }
      break;
    case "UpcomingShowingNotification" :
      match = [
        "View details",
        "/properties/" + source.showing.property.id
      ];
      break;
    case "__unselected" :
      match = Stdlib.panic("Unexpected source.");
      break;
  }
  let link = match[1];
  let tmp;
  let exit$1 = 0;
  switch (source.__typename) {
    case "AgentMatchLogNotification" :
      let match$4 = source.agentMatchLogByType;
      if (match$4 !== undefined) {
        switch (match$4.__typename) {
          case "ForSalePropertyAgentMatchLogV5" :
            let match$5 = match$4.source;
            if (match$5 !== undefined) {
              let match$6 = match$5.agentV2;
              if (match$6 !== undefined && match$6.__typename === "VisibleForSalePropertyAgent") {
                let match$7 = match$6.agent;
                if (match$7 !== undefined) {
                  tmp = JsxRuntime.jsx(AgentProfilePhoto.make, {
                    profilePhoto: match$7.fragmentRefs,
                    className: avatarStyle
                  });
                } else {
                  exit$1 = 1;
                }
              } else {
                exit$1 = 1;
              }
            } else {
              exit$1 = 1;
            }
            break;
          case "__unselected" :
            exit$1 = 1;
            break;
          default:
            let match$8 = match$4.source;
            if (match$8 !== undefined) {
              let match$9 = match$8.agent;
              if (match$9 !== undefined) {
                tmp = JsxRuntime.jsx(AgentProfilePhoto.make, {
                  profilePhoto: match$9.fragmentRefs,
                  className: avatarStyle
                });
              } else {
                exit$1 = 1;
              }
            } else {
              exit$1 = 1;
            }
        }
      } else {
        exit$1 = 1;
      }
      break;
    case "UnfinishedDraftNotification" :
      tmp = JsxRuntime.jsx(NotificationTypeIcon.make, {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "draft",
          size: 30
        })
      });
      break;
    case "UpcomingShowingNotification" :
      let match$10 = source.showing.property.agentV2;
      if (match$10 !== undefined && match$10.__typename === "VisibleForSalePropertyAgent") {
        let match$11 = match$10.agent;
        if (match$11 !== undefined) {
          tmp = JsxRuntime.jsx(AgentProfilePhoto.make, {
            profilePhoto: match$11.fragmentRefs,
            className: avatarStyle
          });
        } else {
          exit$1 = 1;
        }
      } else {
        exit$1 = 1;
      }
      break;
    case "__unselected" :
      exit$1 = 1;
      break;
  }
  if (exit$1 === 1) {
    tmp = JsxRuntime.jsx(AgentProfilePhoto.Avatar.make, {
      alt: "A TAN user",
      className: avatarStyle
    });
  }
  let tmp$1;
  switch (source.__typename) {
    case "AgentMatchLogNotification" :
      let agentMatchLogByType = source.agentMatchLogByType;
      if (agentMatchLogByType !== undefined) {
        switch (agentMatchLogByType.__typename) {
          case "BuyerNeedAgentMatchLogV5" :
            tmp$1 = JsxRuntime.jsx(NotificationWidgetTexts.BuyerNeedMatchText.make, {
              aml: agentMatchLogByType.fragmentRefs
            });
            break;
          case "ForSalePropertyAgentMatchLogV5" :
            tmp$1 = JsxRuntime.jsx(NotificationWidgetTexts.PropertyMatchText.make, {
              aml: agentMatchLogByType.fragmentRefs
            });
            break;
          case "RentalNeedAgentMatchLogV5" :
            tmp$1 = JsxRuntime.jsx(NotificationWidgetTexts.RentalNeedMatchText.make, {
              aml: agentMatchLogByType.fragmentRefs
            });
            break;
          case "RentalPropertyAgentMatchLogV5" :
            tmp$1 = JsxRuntime.jsx(NotificationWidgetTexts.RentalPropertyMatchText.make, {
              aml: agentMatchLogByType.fragmentRefs
            });
            break;
          case "__unselected" :
            tmp$1 = null;
            break;
        }
      } else {
        tmp$1 = null;
      }
      break;
    case "UnfinishedDraftNotification" :
      let match$12 = source.draft;
      let match$13 = match$12.draftProperty;
      if (match$13 !== undefined) {
        let origin = match$12.origin;
        let address = match$13.address;
        let match$14 = Stdlib_Option.map(match$13.userSelectedArea, v => v.name);
        let text = address !== undefined ? (
            match$14 !== undefined ? address + (", " + match$14) : address
          ) : (
            match$14 !== undefined ? match$14 : "(no address entered)"
          );
        if (origin !== undefined && (origin === "BROADCAST_QUIET_SELLER" || origin === "REBROADCAST" || origin === "NEW")) {
          switch (origin) {
            case "BROADCAST_QUIET_SELLER" :
              tmp$1 = `Your draft for broadcasting your quiet seller at ` + text + ` is unfinished`;
              break;
            case "NEW" :
              tmp$1 = `Your draft ` + text + ` is unfinished`;
              break;
            case "REBROADCAST" :
              tmp$1 = `Your draft for rebroadcasting ` + text + ` is unfinished`;
              break;
          }
        } else {
          tmp$1 = "";
        }
      } else {
        tmp$1 = null;
      }
      break;
    case "UpcomingShowingNotification" :
      tmp$1 = JsxRuntime.jsx(NotificationWidgetTexts.ShowingNotification.make, {
        showing: source.showing.fragmentRefs
      });
      break;
    case "__unselected" :
      tmp$1 = null;
      break;
  }
  let tmp$2;
  switch (source.__typename) {
    case "AgentMatchLogNotification" :
      tmp$2 = "MATCH";
      break;
    case "UnfinishedDraftNotification" :
      tmp$2 = "DRAFT";
      break;
    case "UpcomingShowingNotification" :
      tmp$2 = "SHOWING";
      break;
    case "__unselected" :
      tmp$2 = "";
      break;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: tmp,
        className: ""
      }),
      JsxRuntime.jsxs(Link, {
        href: link,
        className: "grow text-zinc-600 hover:text-zinc-600",
        children: [
          JsxRuntime.jsx("div", {
            children: tmp$1,
            className: notification.status === "READ" ? "font-normal" : "font-semibold"
          }),
          JsxRuntime.jsx("div", {
            children: tmp$2,
            className: TailwindMerge.twMerge([
              "underline decoration-dashed decoration-zinc-300",
              notification.status === "READ" ? "font-normal" : "font-bold"
            ])
          })
        ]
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          href: link,
          onClick: onClick,
          size: "small",
          className: "z-10",
          children: match[0]
        }),
        className: "hidden md:block"
      })
    ],
    className: TailwindMerge.twMerge([
      "flex flex-row items-center space-x-4 py-4 px-2 border-b border-gray-200 relative",
      notification.status === "READ" ? "" : "bg-gray-50"
    ])
  });
}

let make = NotificationWidgetItem;

exports.NotificationFragment = NotificationFragment;
exports.NotificationSourceFragment = NotificationSourceFragment;
exports.avatarStyle = avatarStyle;
exports.make = make;
/* IconV5 Not a pure module */
